<div class="wrapper">
  <h2>School Infracture</h2>
  <div class="items">
    <div class="item">
      <div class="image-wrapper">
        <img src="../../assets/images/teacherInfo.png" alt="Classrooms" />
      </div>
      <h3>{{ school?.totalClassroom || "50" }} Classrooms</h3>
      <p>Spacious and well-equipped rooms designed for focused study.</p>
    </div>

    <div class="item">
      <div class="image-wrapper">
        <img src="../../assets/images/ratio.svg" alt="Teacher Student Ratio" />
      </div>
      <h3>
        1 : {{ school.teachersRatio }}
        Teacher Student Ratio
      </h3>
      <p>Hands-on environments fostering scientific exploration.</p>
    </div>
    <div class="item">
      <div class="image-wrapper">
        <img src="../../assets/images/flask1.svg" alt="Laboratories" />
      </div>
      <h3>{{ school?.totalLabs || "3" }} Laboratories</h3>
      <p>Well-maintained spaces for convenience and privacy.</p>
    </div>
    <div class="item">
      <div class="image-wrapper">
        <img src="../../assets/images/computer.png" alt="Computer Lab" />
      </div>
      <h3>{{ school?.totalComputerLabs || "1" }} Computer Lab</h3>
      <p>Expansive grounds that inspire immersive learning.</p>
    </div>

    <div class="item">
      <div class="image-wrapper">
        <img src="../../assets/images/boyInfo.png" alt="Boys Washroom" />
      </div>
      <h3>{{ school?.boysToilet || "5" }} Boys Washroom</h3>
      <p>Clean, accessible facilities ensuring student comfort.</p>
    </div>

    <div class="item">
      <div class="image-wrapper">
        <img src="../../assets/images/girlInfo.png" alt="Girls Washroom" />
      </div>
      <h3>{{ school?.girlsToilet || "4" }} Girls Washroom</h3>
      <p>Well-maintained spaces for convenience and privacy.</p>
    </div>
  </div>
</div>
